export const MessageCenterRouting = {
  path: "/message-center",
  name: "message-center",
  meta: { title: "消息中心", icon: "notification" },
  component: () => import("@/views/message-center/message-page/index.vue"),
};
